import deepAssign from './deep-assign';
export default function deepClone(obj) {
  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return deepClone(item);
    });
  }

  if (typeof obj === 'object') {
    return deepAssign({}, obj);
  }

  return obj;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/deep-clone.js
// module id = 28
// module chunks = 0 1 2 3 4